// extracted by mini-css-extract-plugin
module.exports = {"title":"CreateProfileModal_title__Q4C4V","content":"CreateProfileModal_content__3METZ"};